/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MedicalHistoryService } from './services/medical-history.service';
import { DcUserService } from './services/dc-user.service';
import { UserProfileService } from './services/user-profile.service';
import { TenantService } from './services/tenant.service';
import { TextTemplateService } from './services/text-template.service';
import { DcRoleService } from './services/dc-role.service';
import { AuthenticationService } from './services/authentication.service';
import { OrganizationUnitService } from './services/organization-unit.service';
import { MhInitializationService } from './services/mh-initialization.service';
import { LocationService } from './services/location.service';
import { DepartmentService } from './services/department.service';
import { CustomerService } from './services/customer.service';
import { ConfigurationService } from './services/configuration.service';
import { AgnBookService } from './services/agn-book.service';
import { AppointmentService } from './services/appointment.service';
import { AnimalService } from './services/animal.service';
import { AddressService } from './services/address.service';
import { CollectorService } from './services/collector.service';
import { InstanceService } from './services/instance.service';
import { AgnResourceService } from './services/agn-resource.service';
import { TransferringVetsService } from './services/transferring-vets.service';
import { TimeRangeConfigsService } from './services/time-range-configs.service';
import { StockService } from './services/stock.service';
import { AppResourceGroupService } from './services/app-resource-group.service';
import { HexService } from './services/hex.service';
import { CustomerExternalNumberService } from './services/customer-external-number.service';
import { CustomerCategoryService } from './services/customer-category.service';
import { CustomerCategoryGroupService } from './services/customer-category-group.service';
import { CountryService } from './services/country.service';
import { WeekTemplateTypeService } from './services/week-template-type.service';
import { AppStateGroupService } from './services/app-state-group.service';
import { AppStateActionService } from './services/app-state-action.service';
import { AppReasonService } from './services/app-reason.service';
import { AppReasonGroupService } from './services/app-reason-group.service';
import { AnimalTypesService } from './services/animal-types.service';
import { AnimalExternalNumberService } from './services/animal-external-number.service';
import { AnimalDateTypeService } from './services/animal-date-type.service';
import { AgnPresenceTypeService } from './services/agn-presence-type.service';
import { ServiceArticleTreatmentService } from './services/service-article-treatment.service';
import { VersionService } from './services/version.service';
import { TranslationService } from './services/translation.service';
import { PrescriptionsService } from './services/prescriptions.service';
import { PostAddressService } from './services/post-address.service';
import { NotificationService } from './services/notification.service';
import { MonitorService } from './services/monitor.service';
import { LaboratoryReportsService } from './services/laboratory-reports.service';
import { FirmService } from './services/firm.service';
import { AppStateService } from './services/app-state.service';
import { AgnPresenceService } from './services/agn-presence.service';
import { PrescriptionsInternalApiToBeUsedFromReceiverService } from './services/prescriptions-internal-api-to-be-used-from-receiver.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MedicalHistoryService,
    DcUserService,
    UserProfileService,
    TenantService,
    TextTemplateService,
    DcRoleService,
    AuthenticationService,
    OrganizationUnitService,
    MhInitializationService,
    LocationService,
    DepartmentService,
    CustomerService,
    ConfigurationService,
    AgnBookService,
    AppointmentService,
    AnimalService,
    AddressService,
    CollectorService,
    InstanceService,
    AgnResourceService,
    TransferringVetsService,
    TimeRangeConfigsService,
    StockService,
    AppResourceGroupService,
    HexService,
    CustomerExternalNumberService,
    CustomerCategoryService,
    CustomerCategoryGroupService,
    CountryService,
    WeekTemplateTypeService,
    AppStateGroupService,
    AppStateActionService,
    AppReasonService,
    AppReasonGroupService,
    AnimalTypesService,
    AnimalExternalNumberService,
    AnimalDateTypeService,
    AgnPresenceTypeService,
    ServiceArticleTreatmentService,
    VersionService,
    TranslationService,
    PrescriptionsService,
    PostAddressService,
    NotificationService,
    MonitorService,
    LaboratoryReportsService,
    FirmService,
    AppStateService,
    AgnPresenceService,
    PrescriptionsInternalApiToBeUsedFromReceiverService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
